const tutorial = {
    title: "Witaj w XLplanner!",
    description: "Za chwilę przeprowadzimy Cię przez samouczek, dzięki któremu lepiej poznasz naszą aplikację, a także otrzymasz wiele cennych wskazówek.",
    go: "Do dzieła!",
    end: "Koniec!",
    
    company: {
      title: "Firma",
      subtitle: "Wybierz zakładkę Firma znajdującą się w górnym menu",
      description: "W tej zakładce możesz podejmować najważniejsze akcje związane z Twoją firmą.",
      menu: {
        company: "Firma",
        employees: "Pracownicy",
        drivers: "Kierowcy",
        documents: "Dokumenty",
        myCars: "Moje auta",
        insurance: "Ubezpieczenia"
      },
      details: "Po lewej stronie zobaczysz menu, dzięki któremu będziesz mógł zarządzać swoją firmą. Możesz tutaj m.in.:",
      features: {
        personalize: "Spersonalizować wygląd swojego profilu, dodając zdjęcia firmy",
        addEmployees: "Dodawać pracowników, którzy pomogą Ci zarządzać zleceniami",
        manageDrivers: "Zarządzać kierowcami, którzy będą realizować transporty",
        uploadDocuments: "Przesłać i zweryfikować dokumenty, które pozwolą Ci lepiej zaprezentować swoją firmę",
        addCars: "Dodawać posiadane przez firmę auta i kontrolować ważności ich ubezpieczeń"
      }
    },
    
    wallet: {
      title: "Portfel",
      description: "Jest to miejsce, w którym sprawdzisz stan swojego abonamentu",
      menu: {
        subscription: "Abonament",
        invoices: "Faktury"
      },
      details: "W menu znajdziesz następujące opcje: ",
      details1:"Sprawdź ważność swojego abonamentu oraz przedłuż go",
      details2:"Przeglądaj historię faktur za zakupy i pobierz potrzebne dokumenty"
    },
    
    pilot: {
      exchange: {
        title: "Giełda",
        subtitle: "Przejdź do zakładki Giełda, wybierając ją z górnego menu",
        description: "Giełda to miejsce, w którym możesz wystawiać zlecenia transportowe, a następnie przeglądać oferty złożone przez Pilotów do Twoich zleceń. Masz również możliwość samodzielnie ogłosić się w aplikacji, aby inne firmy mogły łatwo znaleźć Twój profil i skontaktować się z Tobą bezpośrednio na czacie.",
        menu: {
          exchange: "Giełda",
          pilotOffers: "Oferty pilotów",
          transports: "Transporty",
          archive: "Archiwum zleceń"
        },
        details: "Po rozwinięciu menu otrzymasz możliwość:",
        features: {
          browseOrders: "Przeglądania zleceń na giełdzie",
          submitOffers: "Składania ofert do pożądanych zleceń",
          checkStatus: "Sprawdzania aktualnego statusu zleceń, na które aplikujesz",
          addAnnouncement: "Dodanie oferty swojej firmy na liście Ogłoszeń Pilotów",
          browseArchive: "Przeglądania archiwalnych zleceń"
        }
      }
    },
    
    driver: {
      exchange: {
        title: "Giełda",
        subtitle: "Przejdź do zakładki Giełda, wybierając ją z górnego menu",
        description: "Giełda to miejsce, w którym możesz przeglądać zlecenia transportowe wystawione przez firmy, a następnie składać oferty do wybranych zleceń. Ponadto możesz samodzielnie ogłosić się w aplikacji, aby inne firmy mogły łatwo znaleźć Twój profil i skontaktować się z Tobą bezpośrednio na czacie.",
        menu: {
          exchange: "Giełda",
          myOffers: "Moje oferty",
          transports: "Transporty",
          archive: "Archiwum zleceń"
        },
        details: "Po rozwinięciu menu otrzymasz możliwość:",
        features: {
          browseOrders: "Przeglądania zleceń na giełdzie",
          submitOffers: "Składania ofert do pożądanych zleceń",
          checkStatus: "Sprawdzania aktualnego statusu ofert, które złożyłeś",
          addAnnouncement: "Dodanie oferty swojej firmy na liście Ogłoszeń Kierowców",
          browseArchive: "Przeglądania archiwalnych zleceń"
        }
      }
    },
    
    closeDialog: "Ikona zamykania dialogu",
    page: {
      oneOfSix: "1/6",
      twoOfSix: "2/6",
      threeOfSix: "3/6",
      fourOfSix: "4/6",
      fiveOfSix: "5/6",
      sixOfSix: "6/6"
    }
  };
  
  export default tutorial;